import { ShootExecutionStatus } from "enums";
import { ShootBlockingOperation } from "enums/shootBlocking";
import { PiTimer, PiCircleDashed, PiPlay } from "react-icons/pi";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import { TriggerReportApp, TriggerReportReason } from "enums/triggerReport";
import { WppInegibleReason } from "enums/budget";
import { BudgetStatus } from "interfaces/budget";

export const shootBlockingOperationMap: Record<
  ShootBlockingOperation,
  { color: string; label: string }
> = {
  [ShootBlockingOperation.QUARANTINE]: {
    color: "#F5821F",
    label: "Quarentena",
  },
  [ShootBlockingOperation.BLOCKLIST_MANUAL]: {
    color: "#A12B24",
    label: "Blocklist Manual",
  },
  [ShootBlockingOperation.BLOCKLIST_AUTOMATIC]: {
    color: "#EB4237",
    label: "Blocklist",
  },
  [ShootBlockingOperation.ENGAGEMENT]: {
    color: "#1669B6",
    label: "Engajou",
  },
  [ShootBlockingOperation.RESPONSE]: {
    color: "#2C9002",
    label: "Resposta",
  },
  [ShootBlockingOperation.REACTIVATION_MANUAL]: {
    color: "#978E11",
    label: "Reativação Manual",
  },
  [ShootBlockingOperation.REACTIVATION_AUTOMATIC]: {
    color: "#D3C722",
    label: "Reativação",
  },
};

export const shootExecutionFrequency = [10, 20, 30, 40, 60, 120];

export const shootExecutionStatusMap: Record<
  string,
  { color: string; label: string; Icon: any }
> = {
  [ShootExecutionStatus.CANCELLED]: {
    color: "#A12B24",
    label: "Cancelado",
    Icon: CloseOutlined,
  },
  [ShootExecutionStatus.COMPLETED]: {
    color: "#2C9002",
    label: "Concluído",
    Icon: CheckOutlined,
  },
  [ShootExecutionStatus.DRAFT]: {
    color: "#978E11",
    label: "Em Rascunho",
    Icon: PiCircleDashed,
  },
  [ShootExecutionStatus.PLANNED]: {
    color: "#F5821F",
    label: "Planejado",
    Icon: PiTimer,
  },
  [ShootExecutionStatus.RUNNING]: {
    color: "#1669B6",
    label: "Em execução",
    Icon: PiPlay,
  },
};

export const triggerReportReasonMap: Record<
  TriggerReportReason,
  { label: string; color?: string }
> = {
  [TriggerReportReason.ALL]: {
    label: "Todos",
  },
  [TriggerReportReason.QUARANTINE]: {
    label: "Quarentena",
    color: "#F5821F",
  },
  [TriggerReportReason.BLOCKLIST]: {
    label: "Blocklist",
    color: "#EB4237",
  },
  [TriggerReportReason.ENGAGEMENT]: {
    label: "Engajou",
    color: "#1669B6",
  },
  [TriggerReportReason.RESPONSE]: {
    label: "Resposta",
    color: "#2C9002",
  },
  [TriggerReportReason.PROCESSED_STATUS]: {
    label: "Pago",
    color: "#c5d300ff",
  },
  [TriggerReportReason.SEND_ERROR]: {
    label: "Erro no envio",
    color: "#610000ff",
  },
};

export const triggerReportAppMap: Record<string, { label: string }> = {
  [TriggerReportApp.ABANDONED_CART]: {
    label: "Carrinho Abandonado",
  },
  [TriggerReportApp.REPIQUE_CAMPAIGN]: {
    label: "Campanha Repique",
  },
};

export const lastScreenList = [
  { value: "landing-page", label: "landing-page" },
  { value: "pre-cadastro", label: "pre-cadastro" },
  { value: "pp-localizacao", label: "pp-localizacao" },
  { value: "pp_coberturas", label: "pp_coberturas" },
  { value: "pp-coberturas", label: "pp-coberturas" },
  { value: "pp_acomodacao", label: "pp_acomodacao" },
  { value: "pp-acomodacao", label: "pp-acomodacao" },
  { value: "pp_coparticipacao", label: "pp_coparticipacao" },
  { value: "pp-coparticipacao", label: "pp-coparticipacao" },
  { value: "pp_odonto", label: "pp_odonto" },
  { value: "pp-odonto", label: "pp-odonto" },
  { value: "pp_dependentes", label: "pp_dependentes" },
  { value: "pp-dependentes", label: "pp-dependentes" },
  { value: "pp_idades", label: "pp_idades" },
  { value: "prateleira", label: "prateleira" },
  { value: "prateleira_compartilhar_telefone", label: "prateleira_compartilhar_telefone" },
  { value: "prateleira_compartilhar_sucesso", label: "prateleira_compartilhar_sucesso" },
  { value: "prateleira_tela_de_comparação", label: "prateleira_tela_de_comparação" },
  { value: "sobre-plano", label: "sobre-plano" },
  { value: "sobre-plano_compartilhar_telefone", label: "sobre-plano_compartilhar_telefone" },
  { value: "sobre-plano_compartilhar_sucesso", label: "sobre-plano_compartilhar_sucesso" },
  { value: "cadastro", label: "cadastro" },
  { value: "cadastro_adicionar_dependente", label: "cadastro_adicionar_dependente" },
  { value: "cadastro_dados_dependente", label: "cadastro_dados_dependente" },
  { value: "peso_altura", label: "peso_altura" },
  { value: "doencas_preexistentes", label: "doencas_preexistentes" },
  { value: "doencas-preexistentes", label: "doencas-preexistentes" },
  { value: "confirmar_dados", label: "confirmar_dados" },
  { value: "venda_especializada", label: "venda_especializada" },
  { value: "login", label: "login" },
  { value: "esqueceu_senha_cpf", label: "esqueceu_senha_cpf" },
  { value: "esqueceu_senha_token_enviado", label: "esqueceu_senha_token_enviado" },
  { value: "esqueceu_senha_inserir_token", label: "esqueceu_senha_inserir_token" },
  { value: "esqueceu_senha_token_validado", label: "esqueceu_senha_token_validado" },
  { value: "esqueceu_senha_recriar", label: "esqueceu_senha_recriar" },
  { value: "contratos", label: "contratos" },
  { value: "pagamento", label: "pagamento" },
  { value: "gerar_boleto", label: "gerar_boleto" },
  { value: "boas_vindas", label: "boas_vindas" },
  { value: "boas-vindas", label: "boas-vindas" },
  { value: "landing-page", label: "landing-page" },
  { value: "confirmar-dados", label: "confirmar-dados" },
  { value: "doencas-preexistentes", label: "doencas-preexistentes" },
  { value: "finalizacao", label: "finalizacao" },
];

export const funnelChart = [
  { screen: "pre-cadastro", label: "Pré-cadastro" },
  { screen: "pp-localizacao", label: "Localização" },
  { screen: "pp_coberturas", label: "Coberturas" },
  { screen: "pp_acomodacao", label: "Acomodação" },
  { screen: "pp_coparticipacao", label: "Coparticipação" },
  { screen: "pp_odonto", label: "Odonto" },
  { screen: "pp_dependentes", label: "Dependente" },
  { screen: "pp_idades", label: "Idade" },
  { screen: "prateleira", label: "Prateleira" },
  { screen: "sobre-plano", label: "Sobre-plano" },
  { screen: "cadastro", label: "Cadastro" },
  { screen: "cadastro_dados_dependente", label: "Cadastro dependente" },
  { screen: "peso_altura", label: "Peso altura" },
  { screen: "doencas_preexistentes", label: "Doencas pré existentes" },
  { screen: "confirmar_dados", label: "Confirmar dados" },
  { screen: "venda_especializada", label: "Venda especializada" },
  { screen: "login", label: "Login" },
  { screen: "contratos", label: "Contratos" },
  { screen: "pagamento", label: "Pagamento" },
  { screen: "boas_vindas", label: "Boas vindas" },
];

export const budgetWppInegibleReasonMap: Record<WppInegibleReason, { label: string; color?: string }> = {
  [WppInegibleReason.NO]: {
    label: "Pendente",
    color: "#762997",
  },
  [WppInegibleReason.SENT]: {
    label: "Sim",
    color: "#2C9002",
  },
  [WppInegibleReason.QUARANTINE]: {
    label: "Quarentena",
    color: "#F5821F",
  },
  [WppInegibleReason.BLOCKLIST]: {
    label: "Blocklist",
    color: "#EB4237",
  },
  [WppInegibleReason.ENGAGEMENT]: {
    label: "Engajou",
    color: "#1669B6",
  },
  [WppInegibleReason.RESPONSE]: {
    label: "Resposta",
    color: "#2C9002",
  }
};


export const budgetStatusMap: Record<BudgetStatus, { label: string; }> = {
  [BudgetStatus.PENDENTE]: {
    label: "Pendente",
  },
  [BudgetStatus.CANCELADO]: {
    label: "Cancelado",
  },
  [BudgetStatus.AGUARDANDO_PAGAMENTO]: {
    label: "Aguardando Pagamento",
  },
  [BudgetStatus.DEVOLVIDO]: {
    label: "Devolvido",
  },
  [BudgetStatus.AUDITORIA_MEDICA]: {
    label: "Aguardando Auditoria Médica",
  },
  [BudgetStatus.CONFIRMACAO_CLIENTE]: {
    label: "Aguardando Confirmação do Cliente",
  },
  [BudgetStatus.VALIDADO]: {
    label: "Orçamento Validado",
  },
  [BudgetStatus.AUTORIZADO]: {
    label: "Autorizado",
  },
  [BudgetStatus.PROCESSADO]: {
    label: "Processado",
  },
  [BudgetStatus.VALIDADO_SEM_CRITICA]: {
    label: "Validado e Ausente de Crítica",
  },
  [BudgetStatus.EM_DIGITACAO]: {
    label: "Em digitação pela Concessionária",
  },
  [BudgetStatus.ASSINADO_CLIENTE]: {
    label: "Assinado pelo Cliente",
  },
  [BudgetStatus.RECUSADO_CLIENTE]: {
    label: "Orçamento Recusado pelo Cliente",
  },
  [BudgetStatus.CANCELADO_FALTA_PAGAMENTO]: {
    label: "Cancelado p/Falta de Pagamento (07 dias)",
  },
  [BudgetStatus.CANCELADO_DECURSO_PRAZO]: {
    label: "Cancelado p/Decurso de Prazo (25 dias)",
  },
  [BudgetStatus.CANCELAMENTO_DIVERGENCIA_DS]: {
    label: "Cancelamento p/Divergência na D.S",
  },
  [BudgetStatus.VALIDADO_DADOS_DIVERGENTES]: {
    label: "Valido com dados divergentes",
  },
  [BudgetStatus.PAGO_CLIENTE]: {
    label: "Pago pelo cliente",
  },
  [BudgetStatus.PAGO_VENDEDOR]: {
    label: "Pago ao vendedor",
  },
  [BudgetStatus.PENDENCIA_MEDICA]: {
    label: "Pendencia medica",
  },
};

